import Vue from 'vue';
import _ from "lodash";
import { DateTime } from "luxon";

let flatify = (ob, prefix) => { //{a:1,b:{c:2,d:{a:{b:2,dd:222, v:22}}}} -> {a: 1, b.c: 2, b.d.a.b: 2, b.d.a.dd: 222, b.d.a.v: 22}
    //console.log(ob)
    if (!ob) return {};
    return Object.keys(ob).reduce((ns, k) => {
        let new_prefix = (prefix ? prefix + '.' : '') + k;
        if (typeof ob[k] === 'object') {
            ns = Object.assign({}, ns, flatify(ob[k], new_prefix));
        } else ns[new_prefix] = ob[k];
        return ns;
    }, {});
}
//a={"a": 1, "b.c": 2, "b.d.a.b": 2, "b.d.a.dd": 222, "b.d.a.v": 22}

let unflatify = (ob) => {
    let unflatted = {};
    Object.keys(ob).reduce((ns, k) => {
        let splitted = k.split('.'); //b.d.a.b -> [b,d,a,b]
        splitted.reduce((ns, p, i) => {
            if (i === splitted.length - 1) {
                ns[p] = ob[k];
            } else {
                if (!ns[p]) {
                    ns[p] = {}
                }
                return ns[p];
            }
        }, unflatted)

        /*
                for(let i=0;i<splitted.length;i++){

                }*/

        return ns;
    }, {});
    return unflatted;
}



let frameApi = (function() {
    let frameApiStore = {};
    window.addEventListener('message', (e) => {
        //console.log(frameApiStore)
        if (e.data.source === "vue-devtools-backend" || e.data.source === "vue-devtools-proxy") return;
        //console.log("FRAME API MSG",e.data);
        if (frameApiStore[e.data.uid] && frameApiStore[e.data.uid].length > 0) {
            frameApiStore[e.data.uid].forEach((f) => {
                f(e.data);
            });
        }
    });
    return function(frame) {
        let uid = Math.round(Math.random() * 1000000);
        frameApiStore[uid] = [];
        return {
            on(condition, fn) {
                frameApiStore[uid].push(function(data) {
                    if (data.mode === condition) {
                        fn(data);
                    }
                });
            },
            send(dataToSend = {}, fn) {
                dataToSend.uid = uid;
                frame.contentWindow.postMessage(dataToSend, "*");
                frameApiStore[uid].push(fn);
            }
        }
    }
})()


let crudApi = {
    makeStore(self, storeName, storeEndpoint) {
        if (!self.$store.state.waitLoad) self.$store.state.waitLoad = [];
        if (!self.$store.state[storeName]) {
            self.$store.registerModule(storeName, {
                state: {
                    list: [],
                    loaded: false,
                    total: 0,
                    current: 0
                },
                mutations: {
                    [storeName + "UpdateCRUD"]: (state, item) => {
                        let foundIndex = state.list.findIndex((p) => {
                            if (p._id === item._id) return true;
                            else return false;
                        });
                        if (foundIndex != -1) {
                            state.list[foundIndex] = item;
                        } else {
                            state.list.push(item);
                        }
                    },
                    [storeName + "RemoveCRUD"]: (state, _id) => {
                        state.list = state.list.filter(f => { return f._id !== _id });
                    }
                },
                actions: {
                    [storeName + "FetchCRUD"]: ({
                        state
                    }) => {
                        self.$http.get(storeEndpoint, { params: { loadFull: true } }).then((res) => {
                            let {
                                error,
                                total
                            } = res.body;
                            if (error) return;

                            state.list = res.body[storeName];
                            state.loaded = true;
                            state.total = total;
                        });
                    },
                    [storeName + "RemoveCRUD"]: ({ commit }, _id) => {
                        self.$http.delete(storeEndpoint, { body: { _id } }).then((res) => {
                            if (res.error) return;
                            commit(storeName + "RemoveCRUD", _id);
                        });
                    },
                    [storeName + "SaveCRUD"]: ({ commit }, item) => {
                        self.$http.post(storeEndpoint, item).then((res) => {
                            item._id = res.body._id;
                            commit(storeName + "UpdateCRUD", item);
                        });
                    }
                }
            });
            self.$store.state.waitLoad.push(storeName);
        }

        if (!self.$store.state[storeName].loaded) self.$store.dispatch(storeName + 'FetchCRUD');
    }
}


let bus = new Vue();

let iCur = {
    totals(arr = [], fields = []) {
        let self = this;
        let totals = {};
        fields.forEach(function(field) {
            if (!totals[field]) totals[field] = {};
            arr.forEach((sI) => {
                if (!sI[field]) return;
                totals[field] = self.sum(sI[field], totals[field]);
            });
        });
        return totals;
    },
    eq(a, b) { //less or equal to
        let loet = false;
        Object.keys(a).forEach((aKey) => {
            if (a[aKey] == b) {
                loet = true;
            }
        });
        return loet;
    },
    lt(a, b) { //less or equal to
        let loet = false;
        Object.keys(a).forEach((aKey) => {
            if (a[aKey] < b) {
                loet = true;
            }
        });
        return loet;
    },
    gt(a, b) { //great than
        let loet = false;
        Object.keys(a).forEach((aKey) => {
            if (typeof b === "number") {
                if (a[aKey] > b) {
                    loet = true;
                }
            } else if (typeof b === 'object') {
                if (a[aKey] > b[aKey]) {
                    loet = true;
                }
            }
        });
        return loet;
    },
    loet(a, b) { //less or equal to
        let loet = false;
        Object.keys(a).forEach((aKey) => {
            if (a[aKey] <= b) {
                loet = true;
            }
        });
        return loet;
    },
    sum(a, b) {
        let sum = {};
        if (!a) return b;
        if (!b) return a;
        Object.keys(a).forEach((aKey) => {
            sum[aKey] = a[aKey];
        });

        Object.keys(b).forEach((bKey) => {
            if (!sum[bKey]) sum[bKey] = b[bKey];
            else sum[bKey] = sum[bKey] + b[bKey];
        })
        return sum;
    },
    sub(a, b) {
        let sub = {};
        if (!a) return -b;
        if (!b) return a;
        Object.keys(a).forEach((aKey) => {
            if (!a[aKey]) a[aKey] = 0;
            sub[aKey] = a[aKey];
        });

        Object.keys(b).forEach((bKey) => {
            if (!b[bKey]) b[bKey] = 0;
            if (!sub[bKey]) sub[bKey] = -b[bKey];
            else sub[bKey] = sub[bKey] - b[bKey];
        })
        return sub;
    },
    mul(a, b) {
        if (!a || !b) return {};
        let newA = {};
        Object.keys(a).map((aKey) => {
            newA[aKey] = a[aKey] * b;
        });
        return newA;
    },
    rvs(a) {
        if (!a) return {};
        let newA = {};
        Object.keys(a).map((aKey) => {
            newA[aKey] = -a[aKey];
        });
        return newA;
    },
    clone(a) { return JSON.parse(JSON.stringify(a)) }
}


//let clone = (a) => { return JSON.parse(JSON.stringify(a)) };


let today = () => {
    let td = new Date();
    td.setHours(0, 0, 0, 0);
    return td;
}




let makeDate = (v) => {
    return DateTime.fromISO(v, { zone: 'utc' });
}



function setByPath(data, path, value) {
    let splittedPath = path.split('.');
    let i_data = _.cloneDeep(data);
    splittedPath.reduce((ns, p, i) => {
        if (i === splittedPath.length - 1) { // if it end of path
            ns[p] = value;
        } else {
            if (!ns) ns = {};
            if (!ns[p]) ns[p] = {};
            return ns[p];
        }
    }, i_data);
    return i_data;
}




function scrollTo(to, duration) {
    var start = window.scrollY,
        change = to - start,
        currentTime = 0,
        increment = 20;

    var animateScroll = function() {
        console.log("animation");
        currentTime += increment;
        var val = Math.easeInOutQuad(currentTime, start, change, duration);
        window.scrollTo(0, val);
        if (currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
}

//t = current time
//b = start value
//c = change in value
//d = duration
Math.easeInOutQuad = function(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
};



function showPashal() {
    let d = document.createElement('div');
    d.className='animated-blur-in';
    d.innerText = "made by Sergazin Software";
    document.body.appendChild(d);
}



(function() {
    let arr = [];
    let str = 'sergazinsoftware';
    document.body.addEventListener('keypress', (e) => {
        arr.push(e.key);
        if (arr[arr.length - 1] != str[arr.length - 1]) {
            arr = [];
        }
        if (arr.length === 16) {
            showPashal();
        }
    });
})()



window._i = {
    setByPath,
    makeDate,
    flatify,
    unflatify,
    frameApi,
    crudApi,
    scrollTo,
    bus,
    iCur,
    clone: _.cloneDeep,
    today,
    /*date(val, dateFormat = 'DD-MM-YYYY  HH-mm') {
        console.error("_i.date is USTAREL!")
        //return moment(val).locale("ru").format(dateFormat);
    },*/
    url(val) {
        return {
            get(attr) {
                let url = document.createElement('a');
                url.setAttribute('href', val);
                return url[attr];
                //"hostname","port","search","pathname","protocol"




            }
        };
    },
    seo: {
        meta: {
            lang: localStorage.lang || "ru",
            lang_support: true,
            title: {},
            description: {},
            website_name: {},
            section: {},
            image: "",
            metas_injected: false,
            tags: {}
        },
        injectMeta(k, v) {
            if (this.meta.tags[k]) {
                this.meta.tags[k].content = v;
            } else {
                let meta = document.createElement('meta');
                meta.name = k;
                meta.content = v;
                document.head.appendChild(meta);
                this.meta.tags[k] = meta;
            }
        },
        setAll() {
            let { meta: { lang, title = {}, section, image, description, website_name } } = this;
            let ttl = title[lang] || "";
            if (section[lang]) {
                ttl += " | " + section[lang];
            }
            if (website_name[lang]) {
                ttl += " | " + website_name[lang];
            }
            document.title = ttl;
            this.injectMeta('og:title', ttl);
            this.injectMeta('description', description && description[lang]);
            this.injectMeta('og:description', description && description[lang]);
            this.injectMeta('og:image', image);

        },
        load(_seo) {
            this.meta = Object.assign({}, this.meta, _seo);
            this.setAll();
        }
    }
}